module.exports = __webpack_public_path__ + "img/BKSH1.81fa4987.jpg";